import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { async } from '@angular/core/testing';
import { Component, EventEmitter, Input, OnInit, Output, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { RequestAccessTypesEnum } from 'src/app/shared/enum/request-access-types.enum';
import { ModalService } from 'src/app/shared/services/modal.service';
import { MAT_DIALOG_DATA } from '@angular/material';
import { AddSupplierUserComponent } from '../../users/add-supplier-user/add-supplier-user.component';
import { AddCustomerUserComponent } from '../../users/add-customer-user/add-customer-user.component';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';
import * as _ from 'lodash';

@Component({
  selector: 'request-modal',
  templateUrl: './request-modal.component.html',
  styleUrls: ['./request-modal.component.scss']
})
export class RequestModalComponent implements OnInit {

  constructor(
    private customerService: CustomerService,
    private flashMessageService: FlashMessageService,
    private _currentUserService: CurrentUserService,
    private _gaSvc: GoogleAnalyticsService,
    private route: ActivatedRoute,
    private modal: ModalService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.requestType = this.data.requestType;
  }

  public uses: any = [];
  public request: any = {};
  public loading: boolean = false;
  public delayTimer: any;
  public raTypes = RequestAccessTypesEnum;
  public urlPath;
  public requestType;
  public requestTypesArray = [];
  public selectedRequestedType;

  ngOnInit() {
    this.loading = true;
    this.requestTypesArray = Array.from(
      Object.keys(RequestAccessTypesEnum).map(k => RequestAccessTypesEnum[k as any])
    ).filter(reqType => reqType !== RequestAccessTypesEnum.DRIVER);

    if (this.data.requestType === this.raTypes.CARRIER || this.data.requestType === this.raTypes.FACTORING_COMPANY) {
      this.customerService.getCarrierRequest(this.data.requestId, this.data.requestType)
        .then((resp) => {
          this.request = resp;
          this.loading = false;
          this.urlPath = this.route.snapshot;

          this._gaSvc.register(`Carrier Admin`, `Manage Request`, `${this.request.email}, ${this.request.companyName}`);
        }).catch((error) => {
          this.loading = false;
          this.flashMessageService.updateMessage(error.message);
        });

    } else {
      this.customerService.getCustomerRequest(this.data.requestId, this.data.requestType)
        .then((resp) => {
          this.request = resp;
          this.loading = false;
          this.urlPath = this.route.snapshot
        }).catch((error) => {
          this.loading = false;
          this.flashMessageService.updateMessage(error.message);
        });
    }
  }

  public async transferRequest() {
    if (this.selectedRequestedType) {
      try {
        this.loading = true;
        const sourceRequestType = this.data.requestType;
        const targetRequestType = this.selectedRequestedType;
        const loggedInEmail = (await this._currentUserService.getUser()).email.toLowerCase();

        // Append comment info
        const switchMessage = `- This user request was switched from ${sourceRequestType} to ${targetRequestType} by ${loggedInEmail}.`;
        this.request.comments = this.request.comments ?  `${this.request.comments} \n\n${switchMessage}` : switchMessage;

        if (sourceRequestType === this.raTypes.CUSTOMER || sourceRequestType === this.raTypes.SUPPLIER) {
          // customer and suplier and don't store firstName and lastName
          this.request.firstName = this.request.name.split(" ")[0];
          this.request.lastName = this.request.name.split(" ")[1];
        }

        // Add to new destination
        if (targetRequestType === this.raTypes.CARRIER || targetRequestType === this.raTypes.FACTORING_COMPANY) {
          this.request.requestType = targetRequestType;
          this.customerService.newCustomerUserRequest = _.cloneDeep(this.request);
          delete this.customerService.newCustomerUserRequest._id // force new ID to be created
          await this.customerService.createCarrierRequest();
        } else if (targetRequestType === this.raTypes.CUSTOMER || targetRequestType === this.raTypes.SUPPLIER) {
          this.request.requestType = targetRequestType;
          this.customerService.newCustomerUserRequest = this.request;
          await this.customerService.createCustomerRequest();
        }

        // Remove from request source
        if (sourceRequestType === this.raTypes.CARRIER || sourceRequestType === this.raTypes.FACTORING_COMPANY) {
          await this.customerService.removeCarrierRequest(this.request._id, sourceRequestType);
        } else if (sourceRequestType === this.raTypes.CUSTOMER || sourceRequestType === this.raTypes.SUPPLIER) {
          await this.customerService.removeCustomerRequest(this.request._id, sourceRequestType);
        }

        this._gaSvc.register(`Internal Admin`, `Manage Request`, `User switched from ${sourceRequestType} to ${targetRequestType} by ${loggedInEmail}.`);
        this.close();
      } catch (err) {
        this.flashMessageService.updateMessage("Failed to switch user request.");
      } finally {
        this.loading = false;
      }
    }
  }

  public deleteRequest() {
    this.loading = true;
    if (this.data.requestType === this.raTypes.CARRIER || this.data.requestType === this.raTypes.FACTORING_COMPANY) {
      this.customerService.removeCarrierRequest(this.data.requestId, this.data.requestType)
        .then((resp) => {
          this._gaSvc.register(`User Admin`, `Delete Request`, `${this.data.requestType}`);
          this.loading = false;
          this.modal.close();
        }).catch((err) => {
          this.loading = false;
          this.modal.close();
          this.flashMessageService.updateMessage('There was an issue removing this request.');
        });
    } else {
      this.customerService.removeCustomerRequest(this.data.requestId, this.data.requestType)
        .then((resp) => {
          this.loading = false;
          this.modal.close();
        }).catch((err) => {
          this.loading = false;
          this.modal.close();
          this.flashMessageService.updateMessage('There was an issue removing this request.');
        });
    }
  }

  public onParamChange() {
    this.loading = true;
    this.customerService.updateCustomerRequest(this.data.requestId, this.request.followUp, this.request.comments, this.data.requestType)
      .then((resp) => {
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      });
  }
  onTextInput() {
    let self = this;
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(function () {
      self.onParamChange();
    }, 1000);
  }

  public close() {
    if (this.data.requestType === this.raTypes.CARRIER) {
      this._gaSvc.register(`Carrier Admin`, `Manage Request`, `${this.request.email}, ${this.request.companyName}`);
    }
    this.modal.close();
  }

  public openModal(type, data = null) {
    if (type === 'supplier') {
      this.modal.close();
      this.modal.open(AddSupplierUserComponent, data);
    }
    else if (type === 'customer') {
      this.modal.close();
      this.modal.open(AddCustomerUserComponent, data);
    }
  }

}

